import { __assign, __awaiter, __generator } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import { Button, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useStoreFileViewerContext } from "../../hooks/context";
import { alertOnError } from "../AlertSnackbar/hooks";
import { FieldsForm, PangeaModal } from "@pangeacyber/react-mui-shared";
import { getCreateProtectedFileFields } from "../CreateNewProtectedFileButton/fields";
var AddFilePasswordButton = function (_a) {
    var object = _a.object, ButtonProps = _a.ButtonProps, _b = _a.onClose, onClose = _b === void 0 ? function () { } : _b;
    var theme = useTheme();
    var _c = useStoreFileViewerContext(), apiRef = _c.apiRef, reload = _c.reload, configurations = _c.configurations;
    var _d = useState(false), open = _d[0], setOpen = _d[1];
    var handleClose = function () {
        setOpen(false);
        onClose();
    };
    var fields = useMemo(function () {
        var _a;
        return getCreateProtectedFileFields({
            policy: (_a = configurations === null || configurations === void 0 ? void 0 : configurations.passwordPolicy) !== null && _a !== void 0 ? _a : {
                chars_min: 8,
            },
        });
    }, [configurations]);
    return (_jsxs(_Fragment, { children: [_jsx(Button, __assign({ sx: { width: "100%" }, variant: "text", startIcon: _jsx(LockOutlinedIcon, { fontSize: "small" }), onClick: function () { return setOpen(true); } }, ButtonProps, { children: "Add password" })), _jsx(PangeaModal, { open: open, onClose: handleClose, displayCloseIcon: true, title: "", header: _jsxs(Stack, { children: [_jsx(Stack, { direction: "row", width: "100%", alignItems: "center", justifyContent: "space-between", children: _jsx(Typography, { variant: "h5", sx: { overflow: "hidden", wordBreak: "break-all" }, children: "Protect using password" }) }), _jsx(Typography, { variant: "body2", color: "textSecondary", children: "Requires a password to decrypt before downloading." })] }), size: "medium", children: _jsx(_Fragment, { children: _jsx(FieldsForm, { object: object, fields: fields, clearable: true, onCancel: handleClose, onSubmit: function (values) { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                if (!apiRef.update)
                                    return [2 /*return*/];
                                return [2 /*return*/, apiRef
                                        .update({
                                        id: object.id,
                                        add_password: values.password,
                                        add_password_algorithm: "AES-CFB-256",
                                    })
                                        .then(function () {
                                        handleClose();
                                        reload();
                                    })
                                        .catch(function (err) {
                                        alertOnError(err);
                                    })];
                            });
                        }); }, StackSx: {
                            ".MuiFormControl-root": {
                                margin: 0,
                            },
                        } }) }) })] }));
};
export default AddFilePasswordButton;
